"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Error = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var Error = function Error(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon.default, _extends({
    viewBox: "0 0 108 108"
  }, props), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "54",
    cy: "54",
    r: "52.5",
    stroke: "#D81A26",
    strokeWidth: "3"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "51",
    y: "22",
    width: "6",
    height: "47",
    rx: "1",
    fill: "#D81A26"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "51",
    y: "80",
    width: "6",
    height: "6",
    rx: "1",
    fill: "#D81A26"
  }));
};
exports.Error = Error;